import { render, staticRenderFns } from "./SalesSource.vue?vue&type=template&id=2234ecfc&scoped=true&"
import script from "./SalesSource.vue?vue&type=script&lang=js&"
export * from "./SalesSource.vue?vue&type=script&lang=js&"
import style0 from "./SalesSource.vue?vue&type=style&index=0&id=2234ecfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234ecfc",
  null
  
)

export default component.exports